import { AxiosResponse } from "axios";
import { AxiosInterceptedResult } from "../../api/interceptors";
import { IServerPatchResponse } from "../../components/course-author/helpers/patches";
import { PreferredLocale } from "../../utils/locales";
import { ClientFeature } from "../../parsers/login";

export type UserAccountPatchResponse = AxiosInterceptedResult<IServerPatchResponse>;

export type UserIdResponse = AxiosInterceptedResult<string[]>;

export interface IEditAccountOperations {
  modifyTitle: (title: string) => Promise<UserAccountPatchResponse>;
  addEmailAddress: (emailAddress: string) => Promise<UserAccountPatchResponse>;
  modifyEmailAddress: (emailAddress: string) => Promise<UserAccountPatchResponse>;
  deleteEmailAddress: () => Promise<UserAccountPatchResponse>;
  undeleteEmailAddress: () => Promise<UserAccountPatchResponse>;
  addAccountAlias: (orgId: string, alias: string) => Promise<UserAccountPatchResponse>;
  modifyAccountAlias: (orgId: string, alias: string) => Promise<UserAccountPatchResponse>;
  deleteAccountAlias: () => Promise<UserAccountPatchResponse>;
  undeleteAccountAlias: () => Promise<UserAccountPatchResponse>;
  modifyPassword: (password: string) => Promise<AxiosResponse>;
  modifyPreferredLocale: (newLocale: PreferredLocale | null) => Promise<UserAccountPatchResponse>;
  insertClientFeature: (newClientFeature: ClientFeature) => Promise<UserAccountPatchResponse>;
  deleteClientFeature: (clientFeature: ClientFeature) => Promise<UserAccountPatchResponse>;
  modifyOwningOrg: (newOwningOrgId: string) => Promise<UserAccountPatchResponse>;
  migrateAccountAlias: (oldOwningOrgId: string) => Promise<UserAccountPatchResponse>;
  deleteAccount: () => Promise<UserAccountPatchResponse>;
}

export interface ElementState {
  value: string | undefined;
  isDeleted: boolean;
}

export enum AliasTag {
  InvalidAlias = "invalid-alias",
  GrantedAlias = "granted-alias",
  RequestedNewAlias = "requested-new-alias",
  RequestedChangeAlias = "requested-change-alias",
}

export enum EmailAddressTag {
  ClaimedAddress = "claimed-address",
  AdminClaimedAddress = "admin-claimed-address",
  InvalidAddress = "invalid-address",
  DuplicateAddress = "duplicate-address",
  VerifiedAddress = "verified-address",
  VerificationMailSent = "verification-mail-sent",
}

export interface IModalSettings {
  modalMsg: string | undefined;
  showModal: boolean;
}
